<template>
  
  <DeleteCameraModal />
  <CreateCameraModal />
  <UpdateCameraModal />
  <AiMonitoringRegionModal :camera="regionCamera" @saved="handleRegionSaved" />

  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing radius-7">
    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25 radius-7"
    >
      <div class="d-sm-flex align-items-center">
          <h4 class="mb-0">Cameras</h4>
      </div>

      <div v-if="getConfigurations.adm" class="d-sm-flex align-items-center">
        <a
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-flex me-10 mb-10 mb-lg-0 text-decoration-none ms-0 align-items-center fit-content"
          href="#"
          data-bs-toggle="modal"
          data-bs-target="#CreateCameraModal"
        >
          Criar nova camera
          <i class="flaticon-video-camera-1 position-relative ms-5 fs-16 d-flex"></i>
        </a>
      </div>
    </div>



    <div class="card-body p-15 p-sm-20 p-md-25 mt-10">
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
              >
                Nome
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                url
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                IA
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Gravando
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Data de criação
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                status
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
              >
                Editar
              </th>
            </tr>
          </thead>
          <tbody>


            <tr v-for="(value, key) in getCameras" :key="key">
              
              <th class="shadow-none lh-1 fw-medium text-black-emphasis title ps-0">
                <div class="d-flex align-items-center">
                  <div class="d-flex align-items-center ms-5 fs-md-15 fs-lg-16">
                    {{ value.name }}
                  </div>
                </div>
              </th>

              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                <div class="camera-url-wrapper">
                  <span class="camera-url-text">{{ value.url }}</span>
                  <button
                    type="button"
                    class="copy-url-button"
                    :title="copiedCameraId === value.id ? 'URL copiada' : 'Copiar URL'"
                    @click="copyCameraUrl(value)"
                  >
                    <i
                      :class="copiedCameraId === value.id ? 'ph ph-check' : 'ph ph-copy'"
                      class="position-relative fs-16 d-flex"
                    ></i>
                  </button>
                </div>
              </td>

              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                <span class="ai-status-badge" :class="getAiStatusClass(value)">
                  {{ getAiStatusLabel(value) }}
                </span>
                <small v-if="value.ai_monitoring_enabled" class="ai-region-status d-block mt-1">
                  {{ hasAiRegion(value) ? 'Perímetro configurado' : 'Quadro inteiro' }}
                </small>
              </td>
              
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                <i :class="{'ph ph-x-circle': !value.record, 'ph ph-check-circle': value.record}" class=" lh-1 position-relative top-1 fs-16"></i>
                {{ value.record == 1 ? 'Sim' : 'Não' }}
              </td>
              
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ value.created_at }}
              </td>
              
              <td :class="{'active-column': value.active, 'inactive-column': !value.active}" class="shadow-none lh-1 fw-medium text-black-emphasis">
                <i :class="{'ph ph-x-circle': !value.active, 'ph ph-check-circle': value.active}" class=" lh-1 position-relative top-1 fs-16"></i>
                {{ value.active == 1 ? 'Ativo' : 'Inativo' }}
              </td>

              <td class="shadow-none lh-1 fw-medium text-body-tertiary text-center pe-0 d-flex justify-content-end">

                <a
                  v-if="getConfigurations.adm && value.ai_monitoring_enabled"
                  class="position-relative transition border-0 fw-medium text-white p-10 rounded-1 bg-warning d-flex ms-5 mt-5 me-5 mb-5 text-decoration-none fit-content"
                  href="#"
                  title="Configurar perímetro de monitoramento IA"
                  data-bs-toggle="modal"
                  data-bs-target="#AiMonitoringRegionModal"
                  @click="openRegionEditor(value)"
                >
                  <i class="ph ph-polygon position-relative fs-16 d-flex"></i>
                </a>

                <a
                  class="position-relative transition border-0 fw-medium text-white p-10 rounded-1 bg-info d-flex ms-5 mt-5 me-5 mb-5 text-decoration-none ms-0 fit-content"
                  href="#"
                  data-bs-toggle="modal"
                  data-bs-target="#UpdateCameraModal"
                  @click="setCurrentCamera(value)"
                >
                  <i class="flaticon-edit position-relative fs-16 d-flex"></i>
                </a>
                
              </td>

            </tr>

          </tbody>
        </table>
      </div>
    </div>








  </div>
</template>

<script lang="ts">

import { defineComponent } from "vue";
import { mapGetters, mapActions } from 'vuex';
import DeleteCameraModal from './DeleteCameraModal.vue';
import CreateCameraModal from './CreateCameraModal.vue';
import UpdateCameraModal from './UpdateCameraModal.vue';
import AiMonitoringRegionModal from './AiMonitoringRegionModal.vue';

type RegionCamera = {
  id: number | string;
  ai_monitoring_region?: Array<{ x: number; y: number }> | null;
  [key: string]: unknown;
};

export default defineComponent({
  name: "CamerasList",
  data() {
    return {
      copiedCameraId: null as number | null,
      regionCamera: null as RegionCamera | null,
    };
  },
  computed: {
    ...mapGetters([
      'getCameras',
      'getConfigurations'
    ])
  },
  components: {
    DeleteCameraModal,
    CreateCameraModal,
    UpdateCameraModal,
    AiMonitoringRegionModal
  },
  mounted() {
    this.setManufacturers();
  },
  methods: {
    ...mapActions([
      "setCurrentDeleteUser",
      "setCurrentCamera",
      "setManufacturers",
      "updateCameraAiMonitoringRegion"
    ]),
    openRegionEditor(camera) {
      this.regionCamera = camera;
    },
    handleRegionSaved(payload) {
      this.updateCameraAiMonitoringRegion({
        cameraId: payload.cameraId,
        region: payload.region,
      });
      if (this.regionCamera && Number(this.regionCamera.id) === Number(payload.cameraId)) {
        this.regionCamera.ai_monitoring_region = payload.region;
      }
    },
    hasAiRegion(camera) {
      return Array.isArray(camera.ai_monitoring_region) && camera.ai_monitoring_region.length >= 3;
    },
    async copyCameraUrl(camera) {
      if (!camera.url) {
        return;
      }

      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(camera.url);
        } else {
          this.copyTextFallback(camera.url);
        }

        this.copiedCameraId = camera.id;
        setTimeout(() => {
          if (this.copiedCameraId === camera.id) {
            this.copiedCameraId = null;
          }
        }, 1800);
      } catch (error) {
        this.copyTextFallback(camera.url);
        this.copiedCameraId = camera.id;
      }
    },
    copyTextFallback(text) {
      const input = document.createElement("textarea");
      input.value = text;
      input.setAttribute("readonly", "");
      input.style.position = "fixed";
      input.style.top = "-9999px";
      document.body.appendChild(input);
      input.select();
      document.execCommand("copy");
      document.body.removeChild(input);
    },
    getAiStatusLabel(camera) {
      if (!camera.ai_monitoring_enabled) {
        return "Desativado";
      }

      if (camera.ai_monitoring_status === "monitoring") {
        return "Monitorando";
      }

      if (camera.ai_monitoring_status === "starting") {
        return "Iniciando";
      }

      if (camera.ai_monitoring_status === "error") {
        return "Erro";
      }

      return "Habilitado";
    },
    getAiStatusClass(camera) {
      if (!camera.ai_monitoring_enabled) {
        return "ai-status-disabled";
      }

      if (camera.ai_monitoring_status === "monitoring") {
        return "ai-status-online";
      }

      if (camera.ai_monitoring_status === "error") {
        return "ai-status-error";
      }

      return "ai-status-pending";
    }
  }
});
</script>

<style scoped>
.inactive {
  font-size: 10pt !important;
  padding: 5px 10px !important;
  border-radius: 5px !important;
  background-color: red !important;
  color: #fff !important;
  font-weight: bold;
}

.active {
  font-size: 10pt !important;
  padding: 5px 10px !important;
  border-radius: 5px !important;
  background-color: #06B48A !important;
  color: #fff !important;
  font-weight: bold;
}

.inactive-column {
  font-size: 10pt !important;
  padding: 5px 10px !important;
  background-color: red !important;
  color: #fff !important;
  font-weight: bold;
}

.active-column {
  font-size: 10pt !important;
  padding: 5px 10px !important;
  background-color: #06B48A !important;
  color: #fff !important;
  font-weight: bold;
}

.camera-url-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
  max-width: 650px;
}

.camera-url-text {
  overflow: hidden;
  text-overflow: ellipsis;
}

.copy-url-button {
  width: 32px;
  height: 32px;
  border: 0;
  border-radius: 4px;
  background: #eaf7ff;
  color: #149bd7;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  transition: background-color .2s ease, color .2s ease;
}

.copy-url-button:hover {
  background: #149bd7;
  color: #fff;
}

.ai-status-badge {
  display: inline-flex;
  align-items: center;
  padding: 6px 10px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 700;
}

.ai-status-disabled {
  color: #6c757d;
  background: #eef0f3;
}

.ai-status-online {
  color: #067557;
  background: #d9f7ed;
}

.ai-status-pending {
  color: #856404;
  background: #fff3cd;
}

.ai-status-error {
  color: #a01818;
  background: #ffe1e1;
}
</style>
